import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { SubscribeFormValues } from '../SubscribeFormSchema';
import { getAgreeTestDriveMessage } from '../../../config/defaults';

interface Props {
  register: UseFormRegister<SubscribeFormValues>;
  errors: FieldErrors<SubscribeFormValues>;
  campaignName: string;
  messageOverride?: string | null;
}

export default function AgreeTestDriveField({ register, errors, campaignName, messageOverride }: Props) {
  return (
    <div className="form-row">
      <div className="form-checkbox">
        <input id="subscribe_agreeTestDrive" type="checkbox" className="js-phone-agreement" {...register('agreeTestDrive')} />
        <label htmlFor="subscribe_agreeTestDrive" className="js-phone-agreement-label">
          {getAgreeTestDriveMessage(campaignName, messageOverride)}
          {errors.agreeTestDrive && <div className="form-error">{errors.agreeTestDrive.message}</div>}
        </label>
      </div>
    </div>
  );
}
